<template>
  <div class="homepage-entry">
    <component
      :is="activeHomeComponent"
      v-if="ready && activeHomeComponent"
    />
    <div v-else class="homepage-entry__loading">加载中...</div>
  </div>
</template>

<script>
import systemApi from '@/api/system'
import {
  HOMEPAGE_VERSION_LEGACY,
  HOMEPAGE_VERSION_NEW,
  normalizeHomepageVersion
} from '@/utils/homepageVersion'

const LegacyHome = () => import('./Home.vue')
const LotteryHome = () => import('./LotteryHome.vue')

export default {
  name: 'HomepageEntry',
  data() {
    return {
      ready: false,
      homePageVersion: ''
    }
  },
  computed: {
    /** 后台选择新版时挂载全国开奖，否则挂载原主页。 */
    activeHomeComponent() {
      if (!this.ready) return null
      return this.homePageVersion === HOMEPAGE_VERSION_NEW ? LotteryHome : LegacyHome
    }
  },
  created() {
    this.loadHomepageVersion()
  },
  methods: {
    /** 写入标准化主页版本，并通知外层决定是否展示“全国开奖”标题。 */
    applyHomepageVersion(version) {
      this.homePageVersion = normalizeHomepageVersion(version)
      this.ready = true
      this.$emit('homepage-version-change', this.homePageVersion)
    },
    /** 从公共系统配置读取 SQL 主页版本；失败时使用旧版。 */
    loadHomepageVersion() {
      return systemApi.getConfig()
        .then(res => {
          this.applyHomepageVersion(res && res.__success ? res.data?.homePageVersion : HOMEPAGE_VERSION_LEGACY)
        })
        .catch(() => this.applyHomepageVersion(HOMEPAGE_VERSION_LEGACY))
    }
  }
}
</script>

<style scoped>
.homepage-entry {
  min-height: 100%;
}

.homepage-entry__loading {
  padding: 36px 16px;
  color: #999;
  font-size: 14px;
  text-align: center;
}
</style>
